import { render, staticRenderFns } from "./UeblicherLohnStammdaten.vue?vue&type=template&id=fee21854&scoped=true"
import script from "./UeblicherLohnStammdaten.vue?vue&type=script&lang=js"
export * from "./UeblicherLohnStammdaten.vue?vue&type=script&lang=js"
import style0 from "./UeblicherLohnStammdaten.vue?vue&type=style&index=0&id=fee21854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee21854",
  null
  
)

export default component.exports